"use client";
import { Modal } from "@/components/modal";
import { useRouter } from "next/navigation";

interface CommentDisabledModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onAccept: () => void;
  id: number;
}

export function CommentDisabledModal({
  isOpen,
  onOpenChange,
  onAccept,
  id,
}: CommentDisabledModalProps) {
  const router = useRouter();
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={"Relato"}
      closeButton={{ label: "Não" }}
      buttons={[
        {
          label: "Sim",
          onClick: () => {  
                onAccept()
                router.push(`/votacao/problemas/${id}?relato=true`, {scroll: false})
            }
        },
      ]}
    >
      <div>
        Para que você possa enviar um relato, é necessário primeiro votar no problema. Gostaria de votar?
      </div>
    </Modal>
  );
}
